module.exports = __webpack_public_path__ + "static/media/4.Electric Sprayer.0c0706b5.jpg";